// extracted by mini-css-extract-plugin
module.exports = {"planUsageEdit":"User_planUsageEdit__2eSCn","ordersLabel":"User_ordersLabel__2DyK-"};